import {StyledColorBlock} from '@/pages/styles';
import {forwardRef} from 'react';
import {
  StyledAboutArtistTitle,
  StyledArtistAboutSection,
  StyledAwards,
  StyledBio,
  StyledEducation,
  StyledEvents,
  StyledGridLayout,
  StyledLinks,
  StyledMap,
  StyledSideMenu,
} from './styles';
import {ArtistAboutSectionProps} from './typings';

const ArtistAboutSection = forwardRef<HTMLElement, ArtistAboutSectionProps>(
  ({aboutInfo, artistName, titleBackground}, sectionRef): JSX.Element | null => {
    return !!aboutInfo ? (
      <StyledArtistAboutSection ref={sectionRef}>
        {artistName && (
          <StyledAboutArtistTitle
            $background={titleBackground}
            id="about"
          >{`About ${artistName}`}</StyledAboutArtistTitle>
        )}

        <StyledColorBlock as="div">
          <StyledGridLayout>
            <StyledBio text={aboutInfo.biography.text} />

            <StyledSideMenu>
              <StyledLinks
                socialLinks={aboutInfo.contact_info.social_media}
                website={aboutInfo.contact_info.website}
              />

              <StyledEducation education={aboutInfo.education} />

              <StyledAwards awards={aboutInfo.awards} />

              <StyledEvents
                upcomingEvents={aboutInfo.upcoming_events}
                previousEvents={aboutInfo.previous_events}
              />
            </StyledSideMenu>

            {aboutInfo.biography?.location_map?.image_url && (
              <StyledMap
                src={aboutInfo.biography.location_map.image_url}
                alt={`Home of our wonderful artist`}
                aria-label="Image of the artist's location"
                width={740}
                height={347}
                unoptimized
              />
            )}
          </StyledGridLayout>
        </StyledColorBlock>
      </StyledArtistAboutSection>
    ) : null;
  },
);

ArtistAboutSection.displayName = 'ArtistAboutSection';

export default ArtistAboutSection;
